interface LogoProps {
  size?: number
  light?: boolean
  onClick?: () => void
}

export function Logo({ size = 32, light = false, onClick }: LogoProps) {
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    >
      <div style={{
        width: size, height: size, borderRadius: 9, background: '#0F7C6C',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        font: '700 13px Inter,sans-serif', color: '#fff', flexShrink: 0,
      }}>
        DT
      </div>
      <div style={{ font: '600 18px/1 Lora,serif', color: light ? '#fff' : '#1B2A4A' }}>
        DriveTrack
      </div>
    </div>
  )
}
